import { render, staticRenderFns } from "./testDiffOut.vue?vue&type=template&id=140bdb5b&scoped=true&"
import script from "./testDiffOut.vue?vue&type=script&lang=js&"
export * from "./testDiffOut.vue?vue&type=script&lang=js&"
import style0 from "./testDiffOut.vue?vue&type=style&index=0&id=140bdb5b&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "140bdb5b",
  null
  
)

export default component.exports